/**
 * Suffisso utilizzato per i campi interni al motore e utilizzati
 * per le varie funzionalità. Iniziando per "@" ci assicuriamo che
 * non ci siano collisioni con i campi definiti dall'utente (i quali
 * devono iniziare obbligatoriamente per una lettera e permettono solo
 * lettere, numeri, underscore e "-").
 */
export const EngineInternalFieldSuffix = '@internal';

/**
 * Chiave `.meta()` da utilizzare sullo schema di Yup per indicare che non
 * si tratta di uno schema definito dall'utente ma interno al motore.
 */
export const EngineInternalMetaKey = `__engineInternal`;
